export default __webpack_public_path__ + "static/media/people.eca03b99.png";